import http from "../http-common";

// 休日のチェック
const cld001 = (date) => {
    return http.get(`/cld/clda001`, {
        params: {
            date: date
        },
        withCredentials: true
    });
};

const cldService = {
    cld001
};

export default cldService;
